import gsap from "gsap";

export function createLegendController({
  configs,
  onSelect,
  targetDocument = document,
}) {
  const root = targetDocument.querySelector(".legend");
  const list = targetDocument.querySelector(".legend__list");
  const toggle = targetDocument.querySelector(".legend__toggle");
  const buttonListeners = [];

  function setCollapsed(collapsed) {
    if (!root || !toggle) return;

    root.classList.toggle("is-collapsed", collapsed);
    toggle.setAttribute("aria-expanded", String(!collapsed));
    toggle.setAttribute(
      "aria-label",
      collapsed ? "Legende ausklappen" : "Legende einklappen",
    );
  }

  function handleToggle() {
    setCollapsed(!root?.classList.contains("is-collapsed"));
  }

  function render() {
    if (!list) return;

    configs.forEach((config, index) => {
      const item = targetDocument.createElement("li");
      item.className = "legend__item";

      const button = targetDocument.createElement("button");
      button.className = "legend__button";
      button.type = "button";
      button.dataset.hotspotKey = config.key;
      button.innerHTML = `
        <span class="legend__number" aria-hidden="true">${String(index + 1).padStart(2, "0")}</span>
        <span class="legend__label">${config.label}</span>
        <span class="legend__arrow" aria-hidden="true">&#8599;</span>
      `;

      const handleSelect = () => onSelect(config.key);
      button.addEventListener("click", handleSelect);
      buttonListeners.push({ button, handleSelect });
      item.appendChild(button);
      list.appendChild(item);
    });
  }

  toggle?.addEventListener("click", handleToggle);
  render();

  return {
    reveal() {
      if (!root) return;

      root.setAttribute("aria-hidden", "false");
      gsap.fromTo(
        root,
        { autoAlpha: 0, x: 32 },
        {
          duration: 0.8,
          autoAlpha: 1,
          x: 0,
          ease: "power3.out",
          clearProps: "transform",
        },
      );
    },
    setActive(key = null) {
      list?.querySelectorAll(".legend__button").forEach((button) => {
        const isActive = button.dataset.hotspotKey === key;
        button.classList.toggle("is-active", isActive);

        if (isActive) {
          button.setAttribute("aria-current", "location");
        } else {
          button.removeAttribute("aria-current");
        }
      });
    },
    setCollapsed,
    destroy() {
      toggle?.removeEventListener("click", handleToggle);
      buttonListeners.forEach(({ button, handleSelect }) => {
        button.removeEventListener("click", handleSelect);
      });
      buttonListeners.length = 0;
      if (list) list.replaceChildren();
    },
  };
}
